<template>
  <HomeComponent2
    :title="title"
    :message="message"
    :ignore="ignore"
    :order="order"
    :custom="custom"
  ></HomeComponent2>
</template>

<script>
import { HomeComponent2 } from 'dync-web';

export default {
  name: 'Home',
  components: {
    HomeComponent2
  },
  computed: {
    title() {
      return this.$store.getters['dync-properties/get']('digierge', 'web_home_title');
    },
    message() {
      return this.$store.getters['dync-properties/get']('digierge', 'web_home_message');
    },
    ignore() {
      return this.$store.getters['dync-properties/get']('digierge', 'web_home_ignore') || [];
    },
    order() {
      return this.$store.getters['dync-properties/get']('digierge', 'web_home_order') || [
        '/dync-news',
        '/booking/admin',
        '/keys',
        '/push/admin'
      ];
    },
    custom() {
      return this.$store.getters['dync-properties/get']('digierge', 'web_home_custom') || [];
    }
  }
}
</script>
